export default "__VITE_ASSET__DYrMOFNj__"